import { SessionServiceErrorType } from "../../../../interfaces/session-management/enums/error-type";

export class LogoutError extends Error {
	constructor() {
		super('There was a problem while logging out.');
		this.name = SessionServiceErrorType.LOGOUT_ERROR;

		Object.setPrototypeOf(this, LogoutError.prototype);
	}
}
